// @ts-check
import { view } from '../common/constants'
import {
  SET_MODEL_VIEW
} from '../../redux/actions/actionTypes';

const initialState = {
  modelView: view.EXTERNAL
}

export function viewControlsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MODEL_VIEW:
      const options = {
        modelView: action.payload
      }
      window["updateModel"](options)
      return {
        ...state,
        modelView: action.payload
      }
    default:
      return state;
  }
}
